export enum AfiliadoProducto {
  MPP = "M.P.P (Medicina Prepagada)",
  PBS = "P.B.S",
  PBS_2 = "PBS",
}
export enum AfiliadoProductoCode {
  MPP = "03",
  PBS = "01",
  Ambos = "00",
}
